import { type HgSupportedLanguage } from '@smg-real-estate/domus';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

import useGeoStore from '@/stores/useGeoStore';
import { MapGeoLevel } from '@/types';

export const useDynamicTitle = (): { getDynamicTitle: () => string } => {
  const geoStore = useGeoStore();
  const { getLocationName, getIaziLevelByGeoType } = storeToRefs(geoStore);
  const { t, locale } = useI18n();
  const getDynamicTitle = () => {
    switch (getIaziLevelByGeoType.value) {
      case MapGeoLevel.Canton:
        return t('common.header.canton', [
          getLocationName.value(t, locale.value as HgSupportedLanguage),
        ]) as string;
      case MapGeoLevel.Municipality:
      case MapGeoLevel.Town:
        return t('common.header.municipality', [
          getLocationName.value(t, locale.value as HgSupportedLanguage),
        ]) as string;
      default:
        return t('common.header.country') as string;
    }
  };
  return { getDynamicTitle };
};

export default useDynamicTitle;
